import _styled from "styled-components";
import React from "react";
import Modal from "react-modal";
import { Header } from "../Header/Header";
import { useConfig } from "../Config/useConfig";

function modalParentSelector() {
  return document.getElementById("AppContent") || document.body;
}

var StyledModal = _styled(Modal).withConfig({
  displayName: "ModalScreen__StyledModal",
  componentId: "sc-1exgphc-0"
})(["height:100%;&:focus{outline:0 none;}"]);

export var ModalContainer = _styled.div.withConfig({
  displayName: "ModalScreen__ModalContainer",
  componentId: "sc-1exgphc-1"
})(["min-height:100%;display:flex;flex-direction:column;"]);
export function ModalScreen(_ref) {
  var isOpen = _ref.isOpen,
      className = _ref.className,
      onClose = _ref.onClose,
      actionIcon = _ref.actionIcon,
      onAction = _ref.onAction,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(StyledModal, {
    className: className,
    isOpen: isOpen,
    parentSelector: modalParentSelector,
    closeTimeoutMS: 300
  }, /*#__PURE__*/React.createElement(ModalContainer, null, /*#__PURE__*/React.createElement(Header, {
    onBack: onClose,
    actionIcon: actionIcon,
    onAction: onAction
  }), children));
}